
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.05 1.575h9.9c.826 0 1.5.675 1.5 1.5v1.65c0 .6-.374 1.35-.75 1.725L11.477 9.3c-.45.375-.75 1.125-.75 1.725v3.225c0 .45-.3 1.05-.675 1.275L9 16.2c-.975.6-2.325-.075-2.325-1.275V10.95c0-.525-.3-1.2-.6-1.575l-2.85-3C2.85 6 2.55 5.325 2.55 4.875V3.15c0-.9.675-1.575 1.5-1.575zM8.197 1.575L4.5 7.5","stroke":"#284A33","stroke-width":"1.125","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    